module.exports = __webpack_public_path__ + "img/bk.66ded2af.webp";